module.exports = __webpack_public_path__ + "static/media/card-profile2.b198693d.jpg";